module.exports = __webpack_public_path__ + "media/images/metronic/datatables/sort_asc-3eafd898519988bd34ed2a3dcac93add.png";